import { ArrowSwitcher } from "@/shared/ui";
import CreateCharacterBtnRandom from "@/domains/createCharacter/components/CreateCharacterBtnRandom";

type Props = {
  variants: (string | number)[];
  value: string | number;
  onChange: (value: string | number) => void;
  label: string;
  type?: string;
};

export default function CreateCharacterArrowSwitcher({
  variants,
  value,
  onChange,
  label,
  type,
}: Props) {
  return (
    <div className="bg-dark-800 flex justify-between items-center rounded-xl h-13 shrink-0 pl-5 pr-2 gap-1.5">
      <div className="font-bold mr-auto text-15">{label}</div>
      <ArrowSwitcher value={value} variants={variants} onChange={onChange} type={type} />
      <CreateCharacterBtnRandom variants={variants} onClick={onChange} returnIndex />
    </div>
  );
}
